window.BUS = new Vue()
